import api from '../config/api';

class PackageBuilderService {
  // Build a custom package with flights and hotels
  async buildPackage(params) {
    try {
      console.log('🏗️ Building package:', params);
      const response = await api.post('/package-builder/build', params);
      return response.data;
    } catch (error) {
      console.error('❌ Package build failed:', error);
      throw error;
    }
  }

  // Get featured packages by continent
  async getFeaturedPackages(continent = null, limit = 10) {
    try {
      console.log('🌟 Fetching featured packages:', { continent, limit });
      const params = new URLSearchParams();
      if (continent) params.append('continent', continent);
      if (limit) params.append('limit', limit);
      
      const response = await api.get(`/package-builder/featured?${params}`);
      return response.data;
    } catch (error) {
      console.error('❌ Featured packages fetch failed:', error);
      throw error;
    }
  }

  // Get all continents with featured packages
  async getAllContinents() {
    try {
      const response = await api.get('/package-builder/featured');
      return response.data;
    } catch (error) {
      console.error('❌ All continents fetch failed:', error);
      throw error;
    }
  }

  // Get packages for specific continent
  async getContinentPackages(continent, limit = 10) {
    try {
      const response = await api.get(`/package-builder/featured?continent=${continent}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error(`❌ ${continent} packages fetch failed:`, error);
      throw error;
    }
  }
}

const packageBuilderService = new PackageBuilderService();
export default packageBuilderService;
